module.exports = __webpack_public_path__ + "static/img/p6.595011ec.png";